export interface PasswordRequirement {
  key: string;
  label: string;
  met: boolean;
}

export function validatePassword(password: string): PasswordRequirement[] {
  return [
    {
      key: 'length',
      label: 'At least 8 characters',
      met: password.length >= 8,
    },
    {
      key: 'uppercase',
      label: 'One uppercase letter',
      met: /[A-Z]/.test(password),
    },
    {
      key: 'lowercase',
      label: 'One lowercase letter',
      met: /[a-z]/.test(password),
    },
    {
      key: 'number',
      label: 'One number',
      met: /[0-9]/.test(password),
    },
  ];
}

export function isPasswordValid(password: string): boolean {
  return validatePassword(password).every((req) => req.met);
}
